"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALuckyLamentationAbilityHandler = exports.ALuckyLamentationActorAbilityFactory = exports.ALuckyLamentationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
class ALuckyLamentationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ALuckyLamentation;
        this.__typeName = "ALuckyLamentation";
    }
}
exports.ALuckyLamentationAbilityArgs = ALuckyLamentationAbilityArgs;
let ALuckyLamentationActorAbilityFactory = class ALuckyLamentationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ALuckyLamentation", "AllAllies", 4);
    }
};
ALuckyLamentationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ALuckyLamentation")
], ALuckyLamentationActorAbilityFactory);
exports.ALuckyLamentationActorAbilityFactory = ALuckyLamentationActorAbilityFactory;
let ALuckyLamentationAbilityHandler = class ALuckyLamentationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                const luckIncrease = container.getPercentOfBaseAttributeScore(ability.invokerId, 30, "Agility");
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: allyId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Luck, luckIncrease),
                }));
            }
        });
    }
};
ALuckyLamentationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ALuckyLamentation)
], ALuckyLamentationAbilityHandler);
exports.ALuckyLamentationAbilityHandler = ALuckyLamentationAbilityHandler;
